import { StarIcon } from "lucide-react";
import { AnimatedNumber } from "@/components/motion-primitives/animated-number";

export const RatingCard = ({
  rating: { value, count },
}: {
  rating: DoctorTrainingRating;
}) => {
  return (
    <div className={"flex items-center gap-1.5"}>
      <div className={"w-4"}>
        <StarIcon
          size={"16px"}
          fill={count > 0 ? "#FE9C08" : "transparent"}
          stroke={count > 0 ? "#FE9C08" : "black"}
        />
      </div>
      <div>
        <div className="text-sm leading-tight font-normal text-[#1e1926]">
          {value.toFixed(1)} (<AnimatedNumber value={count} />)
        </div>
      </div>
    </div>
  );
};
